// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkWithIcon_wrapper__iFkna","label":"LinkWithIcon_label__GgEWO"};